import React from 'react';
import { TeamsListPage } from './list';

export const TeamsModule = () => {
  return <TeamsListPage />;
};
